import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToForm = () => {
    const formElement = document.getElementById('lead-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-4'}`} data-id="element-115">
      <div className="container mx-auto px-4" data-id="element-116">
        <div className="flex items-center justify-between" data-id="element-117">
          {/* Logo */}
          <div className="flex items-center" data-id="element-118">
            <a href="/" className="text-2xl font-serif font-bold text-primary tracking-tight" data-id="element-119">
              Premier World Discovery
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-120">
            <a href="#" className="text-primary font-medium hover:text-teal transition-colors" data-id="element-121">
              Group Travel
            </a>
            <a href="#" className="text-gray-600 hover:text-primary transition-colors" data-id="element-122">
              Travel Styles
            </a>
            <a href="#" className="text-gray-600 hover:text-primary transition-colors" data-id="element-123">
              Online Brochure
            </a>
            <a href="#" className="text-gray-600 hover:text-primary transition-colors" data-id="element-124">
              Premier Difference
            </a>
            <a href="#" className="text-gray-600 hover:text-primary transition-colors" data-id="element-125">
              Contact
            </a>
          </nav>

          {/* Desktop CTAs */}
          <div className="hidden lg:flex items-center space-x-4" data-id="element-126">
            <Button variant="outline" size="sm" className="hidden xl:flex" data-id="element-127">
              Book with Web Code
            </Button>
            <Button onClick={scrollToForm} size="sm" data-id="element-128">
              Plan a Group Trip
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-primary" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-129">
            {isMobileMenuOpen ? <X size={24} data-id="element-130" /> : <Menu size={24} data-id="element-131" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg p-4 flex flex-col space-y-4 animate-in slide-in-from-top-5" data-id="element-132">
          <a href="#" className="text-lg font-medium text-primary py-2 border-b border-gray-100" data-id="element-133">
            Group Travel
          </a>
          <a href="#" className="text-gray-600 py-2 border-b border-gray-100" data-id="element-134">
            Travel Styles
          </a>
          <a href="#" className="text-gray-600 py-2 border-b border-gray-100" data-id="element-135">
            Online Brochure
          </a>
          <a href="#" className="text-gray-600 py-2 border-b border-gray-100" data-id="element-136">
            Premier Difference
          </a>
          <a href="#" className="text-gray-600 py-2 border-b border-gray-100" data-id="element-137">
            Contact
          </a>

          <div className="flex flex-col space-y-3 pt-2" data-id="element-138">
            <Button variant="outline" fullWidth data-id="element-139">
              Book with Web Code
            </Button>
            <Button onClick={scrollToForm} fullWidth data-id="element-140">
              Plan a Group Trip
            </Button>
          </div>
        </div>}
    </header>;
}